import { jwtDecode } from "jwt-decode";

export const logout = () => {
  localStorage.removeItem("accessToken");
};

// 有効期限チェック済みのトークンを返す。期限切れなら自動削除してnullを返す
export const getValidToken = () => {
  const token = localStorage.getItem("accessToken");
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
    if (decoded.exp && decoded.exp * 1000 < Date.now()) {
      localStorage.removeItem("accessToken");
      return null;
    }
    return token;
  } catch {
    localStorage.removeItem("accessToken");
    return null;
  }
};

export const getCurrentUser = () => {
  const token = getValidToken();
  if (!token) return null;

  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
};